export default class FirestoreCache {}
